/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverrideJustification } from './OverrideJustification';
import {
  OverrideJustificationFromJSON,
  OverrideJustificationFromJSONTyped,
  OverrideJustificationToJSON,
} from './OverrideJustification';
import type { ResidualRiskLabel } from './ResidualRiskLabel';
import {
  ResidualRiskLabelFromJSON,
  ResidualRiskLabelFromJSONTyped,
  ResidualRiskLabelToJSON,
} from './ResidualRiskLabel';
import type { Risk } from './Risk';
import { RiskFromJSON, RiskFromJSONTyped, RiskToJSON } from './Risk';
import type { RiskProfileDimensionRisk } from './RiskProfileDimensionRisk';
import {
  RiskProfileDimensionRiskFromJSON,
  RiskProfileDimensionRiskFromJSONTyped,
  RiskProfileDimensionRiskToJSON,
} from './RiskProfileDimensionRisk';

/**
 *
 * @export
 * @interface PatchedRiskProfileResidualRisk
 */
export interface PatchedRiskProfileResidualRisk {
  /**
   *
   * @type {number}
   * @memberof PatchedRiskProfileResidualRisk
   */
  readonly id?: number;
  /**
   *
   * @type {Risk}
   * @memberof PatchedRiskProfileResidualRisk
   */
  readonly risk?: Risk;
  /**
   *
   * @type {Array<RiskProfileDimensionRisk>}
   * @memberof PatchedRiskProfileResidualRisk
   */
  dimensionRisks?: Array<RiskProfileDimensionRisk>;
  /**
   *
   * @type {ResidualRiskLabel}
   * @memberof PatchedRiskProfileResidualRisk
   */
  readonly calculatedRiskLabel?: ResidualRiskLabel;
  /**
   *
   * @type {ResidualRiskLabel}
   * @memberof PatchedRiskProfileResidualRisk
   */
  readonly riskLabel?: ResidualRiskLabel;
  /**
   *
   * @type {OverrideJustification}
   * @memberof PatchedRiskProfileResidualRisk
   */
  overrideJustification?: OverrideJustification;
  /**
   *
   * @type {string}
   * @memberof PatchedRiskProfileResidualRisk
   */
  mitigation?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PatchedRiskProfileResidualRisk
   */
  isApplicable?: boolean;
}

/**
 * Check if a given object implements the PatchedRiskProfileResidualRisk interface.
 */
export function instanceOfPatchedRiskProfileResidualRisk(value: object): value is PatchedRiskProfileResidualRisk {
  return true;
}

export function PatchedRiskProfileResidualRiskFromJSON(json: any): PatchedRiskProfileResidualRisk {
  return PatchedRiskProfileResidualRiskFromJSONTyped(json, false);
}

export function PatchedRiskProfileResidualRiskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedRiskProfileResidualRisk {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    risk: json['risk'] == null ? undefined : RiskFromJSON(json['risk']),
    dimensionRisks:
      json['dimension_risks'] == null
        ? undefined
        : (json['dimension_risks'] as Array<any>).map(RiskProfileDimensionRiskFromJSON),
    calculatedRiskLabel:
      json['calculated_risk_label'] == null ? undefined : ResidualRiskLabelFromJSON(json['calculated_risk_label']),
    riskLabel: json['risk_label'] == null ? undefined : ResidualRiskLabelFromJSON(json['risk_label']),
    overrideJustification:
      json['override_justification'] == null
        ? undefined
        : OverrideJustificationFromJSON(json['override_justification']),
    mitigation: json['mitigation'] == null ? undefined : json['mitigation'],
    isApplicable: json['is_applicable'] == null ? undefined : json['is_applicable'],
  };
}

export function PatchedRiskProfileResidualRiskToJSON(
  value?: Omit<PatchedRiskProfileResidualRisk, 'id' | 'risk' | 'calculatedRiskLabel' | 'riskLabel'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dimension_risks:
      value['dimensionRisks'] == null
        ? undefined
        : (value['dimensionRisks'] as Array<any>).map(RiskProfileDimensionRiskToJSON),
    override_justification: OverrideJustificationToJSON(value['overrideJustification']),
    mitigation: value['mitigation'],
    is_applicable: value['isApplicable'],
  };
}
